import moment from 'moment';
import XLSX from 'sheetjs-style';
import { BondEntity } from '../../../../entities/bond.entity';
import { SECONDARY } from '../../../../shared/colors';

export const generateBondDataToExport = (bonds: BondEntity[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let b of bonds) {
    toExport.push({
      Index: index,
      Code: b.code,
      Emetteur: b.pays,
      Instrument: b.instrument,
      'Date Emission': b.dateEmission,
      'Date Maturite': b.dateMaturite,
      'Duree Maturite': b.dureeMaturite,
      Coupon: b.tauxMarginal,
      'Valeur Nominale': b.valeurNominale,
      'Fréquence de Paiement': b.frequencePaiement,
      'Date création': `${moment(b.created_at).format('DD/MM/YYYY HH:mm:ss')}`,
    });
    index += 1;
  }

  return toExport;
};

export const generateBondDetailDataToExport = (bonds: BondEntity[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let bond of bonds) {
    for (let det of bond.details) {
      toExport.push({
        Index: index,
        Code: det.parentCode,
        'Sous code': det.subCode,
        Emetteur: bond.pays,
        Instrument: bond.instrument,
        'Date Emission': bond.dateEmission,
        'Date Maturite': bond.dateMaturite,
        'Duree Maturite': bond.dureeMaturite,
        Etat: det.etat,
        Quantite: det.qte,
        'Montant total': det.montant,
        Prix: det.prixNominale,
        'Décote (%)': det.decote,
        'Coupon (%)': bond.tauxMarginal,
        'Rendement (%)': det.tauxRendement,
        'Code origin': det.originCode,
        'Code client': det.detenteur.code_referent,
        'Nom client': det.detenteur.nom + ' ' + det.detenteur.prenom,
        'Date acquisition': `${moment(det.dateAcquisition).format(
          'DD/MM/YYYY',
        )}`,
        'Coupon Couru à Payer': det.couponCouruPayer,
        'Coupon à Percevoir': det.couponPercevoir,
        'Commission Total': det.commissionTotal,
      });
      index += 1;
    }
  }

  return toExport;
};

const countColumns = (data: any[]) => {
  let firstLine = data[0];
  return Object.keys(firstLine).length;
};

export const exportBondsData = (bonds: BondEntity[]) => {
  let wb = XLSX.utils.book_new();
  const bondsData = generateBondDataToExport(bonds);
  const bondDetailsData = generateBondDetailDataToExport(bonds);
  let ws1 = XLSX.utils.json_to_sheet(bondsData);
  let ws2 = XLSX.utils.json_to_sheet(bondDetailsData);

  // style cells
  let numberCols = countColumns(bondsData);
  for (let i = 0; i < numberCols; i++) {
    // style table header
    ws1[`${String.fromCharCode(65 + i)}1`].s = {
      font: {
        name: 'Poppins-B',
        sz: 10,
        color: { rgb: 'FFFFFF' },
      },
      fill: {
        bgColor: SECONDARY,
      },
      border: {
        top: { style: 'thin', color: { rgb: 'FFFFFF' } },
        bottom: { style: 'thin', color: { rgb: 'FFFFFF' } },
        left: { style: 'thin', color: { rgb: 'FFFFFF' } },
        right: { style: 'thin', color: { rgb: 'FFFFFF' } },
      },
    };
    // style content of table
    for (let j = 2; j <= bondsData.length + 1; j++) {
      ws1[`${String.fromCharCode(65 + i)}${j}`].s = {
        font: {
          name: 'Poppins-L',
          sz: 10,
        },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        },
      };
    }
  }
  numberCols = countColumns(bondDetailsData);
  for (let i = 0; i < numberCols; i++) {
    // style table header
    ws2[`${String.fromCharCode(65 + i)}1`].s = {
      font: {
        name: 'Poppins-B',
        sz: 10,
        color: { rgb: 'FFFFFF' },
      },
      fill: {
        bgColor: SECONDARY,
      },
      border: {
        top: { style: 'thin', color: { rgb: 'FFFFFF' } },
        bottom: { style: 'thin', color: { rgb: 'FFFFFF' } },
        left: { style: 'thin', color: { rgb: 'FFFFFF' } },
        right: { style: 'thin', color: { rgb: 'FFFFFF' } },
      },
    };
    // style content of table
    for (let j = 2; j <= bondDetailsData.length + 1; j++) {
      ws2[`${String.fromCharCode(65 + i)}${j}`].s = {
        font: {
          name: 'Poppins-L',
          sz: 10,
        },
        border: {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
        },
      };
    }
  }

  XLSX.utils.book_append_sheet(wb, ws1, 'Etat des titres');
  XLSX.utils.book_append_sheet(wb, ws2, 'Etat détailé des titres');
  XLSX.writeFile(
    wb,
    `Etat des titres - ${moment(new Date()).format('DD/MM/YYYY')}.xlsx`,
  );
};
